<template>
    <div class="my-profile-wrapper">
        <div class="my-profile-card">
            <div class="portrait-container">
                <img v-if="currentUser?.portrait" :src="baseURL + currentUser.portrait">
                <p class="initial" v-else>{{ firstLetterUsername(currentUser?.username) }}</p>
            </div>
            <div class="pfp-uploader">
                <VButton @clickHandler="$refs['pfp-input'].click()" :disabled="uploadMessage !== 'Upload'">{{ uploadMessage }}</VButton>
                <input ref="pfp-input" accept=".jpg,.jpeg,.png" class="pfp-input" type="file" @change="handleFileChange" />
            </div>
            <form class="profile-form-container" @submit.prevent="editUser">
                <VLabeledGroup label="Name">
                    <Textfield v-model="formData.name" :maxlength= 30 />
                </VLabeledGroup>
                <VLabeledGroup label="Username">
                    <Textfield v-model="formData.username" @keydown="handleInput" @paste="handlePaste" :maxlength= 30 />
                </VLabeledGroup>
                <VLabeledGroup label="Email">
                    <Textfield v-model="editedEmail" :placeholder="'Email'" :disabled="true" />
                </VLabeledGroup>
                <VLabeledGroup label="Bio">
                    <TextArea v-model="formData.bio" />
                </VLabeledGroup>
                <div class="profile-btns">
                    <VButton class="update-profile" :disabled="!formUpdated" @clickHandler="editUser" active>Update</VButton>

                    <a href="#" @click.prevent="$emit('show-logout-modal')" class="logout-btn">
                        Logout
                        <i class="icon-logout"></i>
                    </a>
                </div>
            </form>
        </div>

        <Flash ref="show"/>
    </div>
</template>

<script>
import VButton from "@/components/atoms/VButton.vue";
import Textfield from "@/components/atoms/Textfield.vue";
import TextArea from "@/components/atoms/TextArea.vue";
import VLabeledGroup from "@/components/molecules/VLabeledGroup.vue";
import VModal from "@/components/atoms/VModal.vue";
import Flash from "@/components/Flash.vue";
import {api} from "@/mixins/axios";
import {baseURL} from "@/mixins/helpers";

export default {
    components: {VButton, Textfield, TextArea, VModal, Flash, VLabeledGroup},
    props: ['boardOverviewFunc'],
    data() {
        return {
            editedEmail: '',
            uploadMessage: 'Upload',

            formData: {
                name: '',
                username: '',
                bio: ''
            },
            originalData: {},
            modifiedFields: {},
            baseURL: baseURL()
        }
    },
    computed: {
        currentUser() {
            return this.$store.getters.currentUser
        },
        formUpdated() {
            for (const key in this.formData) {
                if (this.formData[key] !== this.originalData[key]) {
                    return true;
                }
            }
            return false;
        }
    },
    watch: {
        currentUser(newVal) {
            if (newVal) {
                this.formData = {
                    name: this.currentUser?.name,
                    username: this.currentUser?.username,
                    bio: this.currentUser?.bio
                }
                this.originalData = { ...this.formData }

                this.editedEmail = this.currentUser?.email
            }
        }
    },
    created() {
        this.formData = {
            name: this.currentUser?.name,
            username: this.currentUser?.username,
            bio: this.currentUser?.bio
        }
        this.originalData = { ...this.formData }

        this.editedEmail = this.currentUser?.email
    },
    methods: {
        async editUser() {
            for (const key in this.formData) {
                if (this.formData[key] !== this.originalData[key]) {
                    this.modifiedFields[key] = this.formData[key];
                }
            }

            if (Object.keys(this.modifiedFields).length === 0) {
                this.$refs.show.showFlashWarning('No field was updated')
                return
            }

            if (this.formData.username.trim() == '') {
                this.$refs.show.showFlashWarning('Field empty')
                return
            }

            this.modifiedFields.id = this.currentUser?.id

            try {
                const response = await api.post("/user_edit", this.modifiedFields);
                if (response.status === 200) {
                    this.searchMeUser()
                    this.originalData = { ...this.formData }
                    this.$store.dispatch('setCurrentUser', response.data.data);
                }
            } catch (e) {
                this.$refs.show.showFlashError(e?.response?.data?.msg || e?.message || 'Something went wrong')
            }
        },
        firstLetterUsername(username) {
            if (typeof username !== 'string' || username.length === 0) {
                return "";
            }
            return username.charAt(0).toUpperCase();
        },
        async handleFileChange(event) {
            const formData = new FormData();
            formData.append('portrait', event.target.files[0]);
			formData.append('token', localStorage.getItem('token'));

            try {
                this.uploadMessage = 'Uploading...'

                const response = await api.post("/user_upload_portrait", formData);
                if (response.data.msg === 'ok') {
                    this.searchMeUser()
                }
            } catch (error) {
                this.$refs.show.showFlashError(error?.response?.data?.msg);
                this.uploadMessage = 'Upload'
            }
        },
        async searchMeUser() {
            try {
                const response = await api.post("/user_me", {});
                if (response.status === 200) {
                    //response.data.data.portrait = `${this.baseURL}${response.data.data.portrait}`
                    localStorage.setItem('currentUser', JSON.stringify(response.data.data))
                    this.$store.dispatch('updateCurrentUser', response.data.data);
                    this.$emit('user-data-saved')
                    this.uploadMessage = 'Upload'
                }
            } catch (e) {
                console.error(e);
            }
        },
        handleInput(_, event) {
            if (event.key == ' ') event.preventDefault()
        },
        handlePaste(event) {
            setTimeout(() => this.formData.username = event.target.value.replace(/\s/g, ''), 10)
        }
    }
}
</script>

<style lang="scss">
.my-profile-wrapper {
    .my-profile-card {
        width: 100%;
        max-width: 412px;
        padding: 40px 0 15px;
        border-radius: 15px;
        backdrop-filter: blur(6px);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        background-color: var(--primary-bg);


        .portrait-container {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            overflow: hidden;
            border: none;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            .initial {
                font-size: 24px;
                font-weight: 600;
                margin-bottom: 0;
            }
        }

        form {
            width: 100%;
            .update-profile {
                height: 30px;
                background: var(--accent);
                color: #fff;
            }
            .profile-btns {
                display: flex;
                justify-content: space-between;
            }
        }

        .pfp-uploader {
            margin: 20px 0;
            .pfp-input {
                display: none;
            }
        }

        .logout-btn {
            display: flex;
            align-items: center;
            gap: 7px
        }

        .profile-form-container textarea {
            border: 0.5px solid var(--outline);
            font-size: 15px;
            min-height: 120px;
        }

        .profile-form-container textarea, .textfield {
            background-color: var(--secondary-bg);
        } 
    }
}
</style>
